(() => {
  const html = document.documentElement;
  const body = document.body;

  if (!body) {
    return;
  }

  const fallbackLocale =
    body.dataset.fallbackLocale?.trim() ||
    html.getAttribute('lang')?.trim() ||
    'pt-BR';

  const fallbackCurrency =
    body.dataset.fallbackCurrency?.trim() ||
    body.dataset.shopCurrency?.trim() ||
    'BRL';

  const shopDomain = body.dataset.shopDomain?.trim();

  window.Shopify = window.Shopify || {};

  if (shopDomain && (!window.Shopify.shop || !String(window.Shopify.shop).trim())) {
    window.Shopify.shop = shopDomain;
  }

  if (!window.Shopify.locale || !String(window.Shopify.locale).trim()) {
    window.Shopify.locale = fallbackLocale;
  }

  window.Shopify.currency = window.Shopify.currency || {};

  if (
    !window.Shopify.currency.active ||
    !String(window.Shopify.currency.active).trim()
  ) {
    window.Shopify.currency.active = fallbackCurrency;
  }

  if (!window.Shopify.currency[window.Shopify.currency.active]) {
    window.Shopify.currency[window.Shopify.currency.active] =
      window.Shopify.currency.active;
  }

  try {
    if (typeof navigator !== 'undefined') {
      if (!navigator.language || !String(navigator.language).trim()) {
        Object.defineProperty(navigator, 'language', {
          configurable: true,
          value: fallbackLocale,
        });
      }

      if (!Array.isArray(navigator.languages) || !navigator.languages.length) {
        Object.defineProperty(navigator, 'languages', {
          configurable: true,
          value: [fallbackLocale],
        });
      }
    }
  } catch (error) {
    console.warn('[Shopify Globals] Unable to normalise navigator language.', error);
  }
})();
